<div class="waec-page-header">
  <img
    class="waec-page-header-image"
    src="/assets/icons/Enquiry.svg"
    alt="Highighted_Access"
  />
  <h3 class="waec-page-header-text">{{'ENQUIRY.HEADER' | translate}}</h3>
</div>

<div class="page-container" nz-row>
  <div class="accountProfile">
    <nz-card class="ant-card-body-main" [nzBordered]="false">
      <!-- TITLE AND DATE PICKER -->
      <div nz-row nzJustify="space-between" nzAlign="end" [nzGutter]="[8, 8]">
        <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="16" nzXl="16">
          <h3 class="waec-card-header-text">{{'GENERAL.ALL_TICKETS' | translate}}</h3>
          <p class="sub-header-text">
            {{'ENQUIRY.SUBHEADER' | translate}}
          </p>
        </div>

        <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="8" nzXl="6">
          <nz-range-picker
            nz-tooltip
            nzTooltipTitle="{{'ENQUIRY.SELECT_DATE_RANGE' | translate}}"
            nzTooltipPlacement="bottom"
            [nzTooltipColor]="'#000148'"
            [nzPlaceHolder]="['GENERAL.START_DATE' | translate, 'GENERAL.END_DATE' | translate]"
            [(ngModel)]="date"
            (ngModelChange)="onFilterByDate($event)"
            class="w-100"
          ></nz-range-picker>
        </div>
      </div>

      <!-- SEARCH AND OPEN TICKET BUTTON -->
      <div
        nz-row
        nzJustify="space-between"
        nzAlign="middle"
        [nzGutter]="[8, 8]"
      >
        <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="16" nzXl="10">
          <form [formGroup]="searchForm" (ngSubmit)="onSearch()">
            <nz-input-group nzSearch [nzAddOnAfter]="suffixButton">
              <input
                type="text"
                nz-input
                placeholder="{{'ENQUIRY.SEARCH_PLACEHOLDER' | translate}}"
                formControlName="search"
              />
            </nz-input-group>

            <ng-template #suffixButton>
              <button
                nz-button
                nzType="primary"
                type="submit"
                [nzLoading]="loading"
                [disabled]="loading"
                nzSearch
              >
                {{'GENERAL.SEARCH' | translate}}
              </button>
            </ng-template>
          </form>
        </div>

        <!-- <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="6" nzXl="4">
          <button nz-button [nzType]="'primary'" nzBlock (click)="openUploadModal()">
            UPLOAD DOCUMENT
          </button>
        </div> -->

        <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="6" nzXl="4">
          <button nz-button [nzType]="'primary'" nzBlock (click)="openTicket()">
            {{'ENQUIRY.OPEN_TICKET' | translate}}
          </button>
        </div>
      </div>

      <!-- TABLE -->
      <div class="container_form">
        <div nz-row>
          <nz-col [nzSpan]="24">
            <div
              nz-col
              class="table-box"
              nzXs="24"
              nzSm="24"
              nzMd="24"
              nzLg="24"
              nzXl="24"
            >
              <nz-table
                #nzTable
                [nzData]="userTickets"
                [nzShowPagination]="false"
                [nzLoading]="loading"
                [nzBordered]="false"
                [nzFooter]="pagination"
              >
                <ng-template #pagination>
                  <div
                    class="pagination-wrapper"
                  >
                    <nz-pagination
                      [nzPageIndex]="current_page"
                      [nzItemRender]="renderItemTemplate"
                      [nzShowTotal]="rangeTemplate"
                      [nzPageSize]="pageSize"
                      [nzTotal]="total"
                    ></nz-pagination>

                    <ng-template #renderItemTemplate let-type let-page="page">
                      <ng-container [ngSwitch]="type">
                        <a *ngSwitchCase="'page'" (click)="next(page)"
                          >{{ page }}</a
                        >
                        <a
                          *ngSwitchCase="'next'"
                          (click)="next(current_page + 1)"
                          ><strong *ngIf="nextPage">{{'GENERAL.NEXT' | translate}}</strong></a
                        >
                        <a *ngSwitchCase="'prev_5'"> << </a>
                        <a *ngSwitchCase="'next_5'">>></a>
                      </ng-container>
                    </ng-template>
                    <ng-template #rangeTemplate let-total>
                      {{ from }}-{{ to }} {{'GENERAL.OF' | translate}} {{ total }} {{'GENERAL.ITEMS' | translate}}
                    </ng-template>
                  </div>
                </ng-template>

                <thead>
                  <tr>
                    <th scope="col" [nzWidth]="'12px'">{{'ENQUIRY.TICKET_ID' | translate}}</th>
                    <th scope="col" [nzWidth]="systemWidth > 576 ? '250px' : '50px'">{{'ENQUIRY.SUBJECT' | translate}}</th>
                    <th scope="col"  [nzWidth]="'12px'">{{'GENERAL.STATUS' | translate}}</th>
                  </tr>
                </thead>

                <!-- Replace newActivity attributed to td ngclass with the property from the backend that indicates new activity  -->
                <tbody>
                  <tr 
                    *ngFor="let ticket of userTickets" 
                    [routerLink]="['/enquiry/ticket-info/' + ticket?.id]"
                  class="ticket"
                  [ngClass]="ticket?.has_new_activity?  'new-activity-indicator': ''" 
                  >
                    <td class="text-black">
                      <span class="ticket-ID" [ngClass]="ticket?.has_new_activity ? 'unread-ID' : ''">{{ ticket?.complaint_id }}</span><br *ngIf="ticket?.updated_at">
                      <span [ngClass]="ticket?.has_new_activity ? 'fw-500' : ''" >{{ ticket?.updated_at | date: "MMM d, y, h:mm a" }} </span><br>
                      <span 
                      *ngIf="systemWidth < 576"
                       [ngClass]="getDocumentStatus(ticket?.documents)==='pending' ? 'upload-required-mobile' : (getDocumentStatus(ticket?.documents) === 'submitted' ? 'awaiting-verification-mobile' : 'd-none')" 
                       class="upload-required-mobile"
                       ><img [src]="getDocumentStatus(ticket?.documents)==='pending' ? './assets/doc.svg' : './assets/doc_yellow.svg'" alt=""/>                    
                      &nbsp;{{getDocumentStatus(ticket?.documents)==='pending' ? ('ENQUIRY.UPLOAD_REQUIRED' | translate) : (getDocumentStatus(ticket?.documents) === 'submitted' ? ('ENQUIRY.PENDING_REVIEW' | translate) : '')}}
                      </span>
                    </td>

                    <td class="text-black text-wrap" [ngClass]="ticket?.has_new_activity ?  'unread-subject': ''">
                      {{ ticket.title | slice : 0 : this.subjectLength }} {{
                      ticket.title.length > this.subjectLength ? "..." : "" }}
                    </td>
                    <!-- <td class="text-black nowrap"  [ngClass]="newActivity ?  'new-activity-indicator': ''">
                      {{ ticket?.updated_at | date: "MMM d, y, h:mm a" }}
                    </td> -->
                    <td class="status-btns-wrapper">
                      <button class="status-btns text-capitalize" [ngClass]="ticket?.status === 'open' ? 'open-status' : 'closed-status'">{{ ticket?.status === 'open' ? ('ENQUIRY.OPEN' | translate) : ('ENQUIRY.CLOSED' | translate) }}</button>
 
                      <span *ngIf="systemWidth > 576">
                        <button
                          *ngIf="ticket?.status === 'open'"
                          [nz-tooltip]="getDocumentStatus(ticket?.documents)==='pending' ? ('ENQUIRY.UPLOAD_REQUIRED' | translate) : (getDocumentStatus(ticket?.documents) === 'submitted' ? ('ENQUIRY.PENDING_REVIEW' | translate) : '')" 
                          nzTooltipPlacement="right"
                          nzTooltipColor="#11105b80"
                          [ngClass]="getDocumentStatus(ticket?.documents)==='pending' ? 'upload-required' : (getDocumentStatus(ticket?.documents) === 'submitted' ? 'awaiting-verification' : 'd-none')" 
                          class="status-btns upload-required"><img src="./assets/icons/document.svg" alt="">
                          {{getDocumentStatus(ticket?.documents)==='pending' ? ('ENQUIRY.UPLOAD_REQUIRED' | translate) : (getDocumentStatus(ticket?.documents) === 'submitted' ? ('ENQUIRY.PENDING_REVIEW' | translate) : '')}}
                        </button>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </nz-table>
            </div>
          </nz-col>
        </div>
      </div>
    </nz-card>
  </div>
</div>